export default {
    HOLD_TIME: 500,
    TRANSITION_DURATION: '250ms',
    SWIPE_VELOCITY_THRESHOLD: 0.4,
    LONG_PRESS_TIMER: 500,
    EXPERIENCE_URL: 'https://experience.glance.com/',
    STORY_PLAYER_DURATION: 7000,
    COACHMARK_ANIMATION_DURATION: '2s',
    CUSTOM_CTA_VERSION: 81900,
    MAIN_BACKGROUND_ID: 'the-background',
    CURRENT_CLASS: 'current',
    NEXT_CLASS: 'next',
    PREV_CLASS: 'prev',
    PREV_BEFORE_CLASS: 'prev2',
    WHATSAPP_SHARE: 'com.whatsapp',
    YOUTUBE_THUMBNAIL: (videoId) => `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`,
    PAGINATION_LIMIT: 20,
    FIRST_PAGINATION_LIMIT: 5,
    UI_ELEMENT_TIMER: 50,
    GCP_API_KEY: 'AIzaSyAlfCtG48rO6c--1GyjXhtYHUXBmesVH8o',
    GCP_PROJECT_ID: 'glancecdn-sandbox-c32a',
    HAS_YOUTUBE_AUTOPLAY: false,
    EMPTY_HTML: '<!DOCTYPE html><html><head><title></title></head><body></body></html>',
    GONDOLIN_BRIDGE: [
        'sendCustomAnalyticsEvent',
        'hideNativeUiElement',
        'isHighlights',
        'unHoldGlance',
        'holdGlance',
        'moveToPrevGlance',
        'moveToNextGlance',
        'getGlanceBackgroundImageUri',
        'showNativeUiElement',
        'getNativeUiElements',
        'getBubbleTrayMode',
        'isSessionMuted',
    ],
};
//# sourceMappingURL=index.js.map